import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom'; // capturar o ID

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import CodeIcon from '@mui/icons-material/Code';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { IconX } from '@tabler/icons';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import 'reactflow/dist/style.css';
import {
    Alert,
    Menu,
    MenuItem,
    ButtonGroup,
    TextField,
    DialogActions,
    DialogContent,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import api from '../../../../services/api';
import './NodeStyle.css';
import Editor from '@monaco-editor/react';

export default function ToolsBuilder({ open, onClose, appId, idFlow, chatbotId }) {
    const [status, setStatus] = useState({ type: '', message: '' });
    const [app_id, setApp_id] = useState(null);
    const [toolFiles, setToolFiles] = useState([]);
    const [selectedTool, setSelectedTool] = useState(null);
    const [tool, setTool] = useState('');
    const [openNewActionDialog, setOpenNewActionDialog] = useState(false);
    const [newToolName, setNewToolName] = useState('');

    const [contextMenu, setContextMenu] = useState(null);
    const [contextFile, setContextFile] = useState(null);

    const [openRenameDialog, setOpenRenameDialog] = useState(false);
    const [renameName, setRenameName] = useState('');

    const [openNewToolDialog, setOpenNewToolDialog] = useState(false);

    const [toolDescription, setToolDescription] = useState('');

    const [toolPrompt, setToolPrompt] = useState('');

    const [parameters, setParameters] = useState([
        {
            name: '',
            type: 'string',
            description: '',
            required: false,
            enumValues: ''
        }
    ]);

    const handleSelectedToolCode = (file) => {
        setSelectedTool(file);

        setNewToolName(file.name || '');
        setToolDescription(file.description || '');

        if (file.parameters_schema?.properties) {
            const params = Object.entries(file.parameters_schema.properties).map(([name, v]) => ({
                name,
                type: v.type || 'string',
                description: v.description || '',
                enumValues: v.enum ? v.enum.join(', ') : '',
                required: file.parameters_schema.required?.includes(name)
            }));

            setParameters(params.length ? params : [{ name: '', type: 'string', description: '', required: false }]);
        }
    };

    // const loadApps = async () => {
    //     try {
    //         if (!idFlow) return;
    //         const res = await api.get(`v1/apps/default/`);
    //         if (res.data) {
    //             setApp_id(res.data.app.id);
    //         }
    //     } catch (err) {
    //         console.error(`ToolsBuilder - loadApps - erro: ${JSON.stringify(err)}`);
    //     }
    // };

    // const loadTools = async () => {
    //     if (!app_id) return;
    //     try {
    //         if (!idFlow) return;
    //         const res = await api.get(`v1/apps/${app_id}/chatbots/${chatbotId}/flow/${idFlow}/tool/`);
    //         if (res.data) {
    //             setToolFiles(res.data);
    //         }
    //     } catch (err) {
    //         console.error(`ToolsBuilder - loadTools - erro: ${JSON.stringify(err)}`);
    //     }
    // };

    // useEffect(() => {
    //     if (!open || !idFlow) return;

    //     const init = async () => {
    //         const res = await api.get(`v1/apps/default/`);
    //         const id = res.data.app.id;

    //         setApp_id(id);

    //         const tools = await api.get(`v1/apps/${id}/chatbots/${chatbotId}/flow/${idFlow}/tool/`);

    //         setToolFiles(tools.data || []);
    //     };

    //     init();
    // }, [open, idFlow, chatbotId]);

    const handleCreateTools = async () => {
        try {
            const formattedName = newToolName.trim().replace(/\s+/g, '_');

            if (!formattedName) {
                setStatus({
                    type: 'error',
                    message: 'Necessário preencher o nome.'
                });
                return;
            }

            const parameters_schema = buildParameterSchema();

            const payload = {
                name: formattedName,
                description: toolDescription,
                parameters_schema,
                prompt: toolPrompt
            };

            console.log(`handleCreateTools - payload:${JSON.stringify(payload)}`);

            const res = await api.post(`v1/apps/${appId}/chatbots/${chatbotId}/flow/${idFlow}/tool/`, payload);

            const newTool = {
                id: res.data.tool,
                name: formattedName,
                description: toolDescription,
                parameters_schema,
                prompt: toolPrompt
            };

            setToolFiles((prev) => [...prev, newTool]);
            setSelectedTool(null);
            setOpenNewToolDialog(false);
        } catch (err) {
            console.error('Erro ao criar tool', err);
        }
    };

    const saveToolFile = async () => {
        try {
            if (!newToolName) {
                setStatus({
                    type: 'error',
                    message: 'Necessário preencher o nome.'
                });
                return;
            }

            const payload = {
                name: newToolName,
                description: toolDescription,
                parameters_schema: buildParameterSchema(),
                prompt: toolPrompt
            };

            await api.patch(`v1/apps/${appId}/chatbots/${chatbotId}/flow/${idFlow}/tool/${selectedTool.id}/`, payload);

            setToolFiles((prev) => prev.map((f) => (f.id === selectedTool.id ? { ...f, ...payload } : f)));

            setSelectedTool(null);
            setOpenNewToolDialog(false);
        } catch (err) {
            console.error(err);
        }
    };

    const deleteToolFile = async () => {
        try {
            await api.delete(`v1/apps/${appId}/chatbots/${chatbotId}/flow/${idFlow}/tool/${selectedTool.id}/`);

            setToolFiles((prev) => prev.filter((f) => f.id !== selectedTool.id));

            setSelectedTool(null);
        } catch (err) {
            console.error(err);
        }
    };

    const handleCloseToolEditor = () => {
        setSelectedTool(null);
        setOpenNewToolDialog(false);
        setStatus({
            type: '',
            message: ''
        });
    };

    const handleRenameTool = async () => {
        try {
            const res = await api.put(`v1/apps/${appId}/chatbots/${chatbotId}/flow/${idFlow}/tool/${contextFile.id}/`, {
                name: renameName
            });

            setToolFiles((prev) => prev.map((f) => (f.id === contextFile.id ? res.data : f)));

            setOpenRenameDialog(false);
        } catch (err) {
            console.error('Erro ao renomear', err);
        }
    };

    const handleDeleteTool = async (file) => {
        try {
            await api.delete(`v1/apps/${appId}/chatbots/${chatbotId}/flow/${idFlow}/tool/${file.id}/`);

            setToolFiles((prev) => prev.filter((f) => f.id !== file.id));

            if (selectedTool?.id === file.id) {
                setSelectedTool(null);
            }
        } catch (err) {
            console.error('Erro ao excluir código', err);
        }
    };

    const addParameter = () => {
        setParameters((prev) => [
            ...prev,
            {
                name: '',
                type: 'string',
                description: '',
                required: false,
                enumValues: ''
            }
        ]);
    };

    const updateParameter = (index, field, value) => {
        setParameters((prev) => {
            const copy = [...prev];
            copy[index] = { ...copy[index], [field]: value };
            return copy;
        });
    };

    const removeParameter = (index) => {
        setParameters((prev) => prev.filter((_, i) => i !== index));
    };

    const buildParameterSchema = () => {
        const properties = {};
        const required = [];

        parameters.forEach((p) => {
            if (!p.name) return;

            properties[p.name] = {
                type: p.type,
                description: p.description
            };

            if (p.enumValues) {
                properties[p.name].enum = p.enumValues
                    .split(',')
                    .map((v) => v.trim())
                    .filter(Boolean);
            }

            if (p.required) {
                required.push(p.name);
            }
        });

        return {
            type: 'object',
            additionalProperties: false,
            properties,
            required
        };
    };

    const validParameters = parameters.filter((p) => p.name);

    return (
        <>
            {/* Drawer ferramentas (left) */}
            <Drawer
                anchor="left"
                open={open}
                onClose={onClose}
                PaperProps={{
                    sx: {
                        width: 380,
                        backgroundColor: '#1e1e1e',
                        color: '#fff',
                        borderRight: '1px solid #2c2c2c'
                    }
                }}
            >
                {/* Header */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px={2}
                    py={1.5}
                    sx={{ borderBottom: '1px solid #2c2c2c' }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        {/* <CodeIcon fontSize="small" /> */}
                        <Typography color="#FFFFFF" variant="h6">
                            Ferramentas 🛠️
                        </Typography>
                    </Box>

                    <IconButton size="small" onClick={onClose}>
                        <IconX fontSize="small" color="#FFFFFF" />
                    </IconButton>
                </Box>

                {/* Lista de ferramentas */}
                <Box sx={{ p: 1, overflowY: 'auto', flex: 1 }}>
                    {toolFiles.map((file) => {
                        const selected = selectedTool?.id === file.id;

                        return (
                            <Box
                                key={file.id}
                                onClick={() => handleSelectedToolCode(file)}
                                onContextMenu={(e) => {
                                    e.preventDefault();
                                    setContextMenu({
                                        mouseX: e.clientX + 2,
                                        mouseY: e.clientY - 6
                                    });
                                    setContextFile(file);
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    px: 1.5,
                                    py: 1,
                                    mb: 0.5,
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    backgroundColor: selected ? '#2e7d32' : 'transparent',
                                    color: selected ? '#fff' : '#ccc',
                                    '&:hover': {
                                        backgroundColor: selected ? '#2e7d32' : '#2a2a2a'
                                    }
                                }}
                            >
                                {/* <CodeIcon fontSize="small" /> */}
                                <Typography variant="body2" color="#FFFFFF" noWrap>
                                    {file.name}
                                </Typography>
                            </Box>
                        );
                    })}
                </Box>

                <Menu
                    open={Boolean(contextMenu)}
                    onClose={() => setContextMenu(null)}
                    anchorReference="anchorPosition"
                    anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
                >
                    <MenuItem
                        onClick={() => {
                            setRenameName(contextFile.name);
                            setOpenRenameDialog(true);
                            setContextMenu(null);
                        }}
                    >
                        ✏️ Renomear
                    </MenuItem>

                    <MenuItem
                        onClick={() => {
                            handleDeleteTool(contextFile);
                            setContextMenu(null);
                        }}
                        sx={{ color: 'error.main' }}
                    >
                        🗑️ Excluir
                    </MenuItem>
                </Menu>

                <Dialog open={openRenameDialog} onClose={() => setOpenRenameDialog(false)}>
                    <DialogTitle>Renomear ferramenta</DialogTitle>

                    <DialogContent>
                        <TextField autoFocus fullWidth value={renameName} onChange={(e) => setRenameName(e.target.value)} />
                    </DialogContent>

                    <DialogActions>
                        <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={() => setOpenRenameDialog(false)}>
                            Cancelar
                        </Button>
                        <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} variant="contained" onClick={handleRenameTool}>
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Footer */}
                <Box
                    sx={{
                        borderTop: '1px solid #2c2c2c',
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1
                    }}
                >
                    <Button
                        onClick={() => {
                            setNewToolName('');
                            setToolDescription('');
                            setParameters([{ name: '', type: 'string', description: '', required: false }]);
                            setOpenNewToolDialog(true);
                        }}
                        startIcon={<AddIcon />}
                        variant="contained"
                        sx={{
                            backgroundColor: '#2e7d32',
                            '&:hover': { backgroundColor: '#1b5e20' }
                        }}
                        fullWidth
                    >
                        Nova ferramenta
                    </Button>

                    <Button onClick={onClose} startIcon={<ArrowBackIcon />} variant="outlined" color="inherit" fullWidth>
                        Voltar
                    </Button>
                </Box>
            </Drawer>
            <Dialog maxWidth={true} fullWidth open={openNewToolDialog} onClose={() => setOpenNewToolDialog(false)}>
                {status.message && (
                    <Alert severity={status.type} sx={{ mb: 2 }}>
                        {status.message}
                    </Alert>
                )}

                <DialogTitle>Novo arquivo de ferramenta</DialogTitle>

                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField label="Nome da ferramenta" value={newToolName} onChange={(e) => setNewToolName(e.target.value)} fullWidth />

                    <TextField label="Descrição" value={toolDescription} onChange={(e) => setToolDescription(e.target.value)} fullWidth />

                    <TextField label="Prompt" value={toolPrompt} onChange={(e) => setToolPrompt(e.target.value)} fullWidth />

                    <Typography variant="subtitle2">Parâmetros</Typography>

                    {parameters.map((param, index) => (
                        <Box
                            key={index}
                            sx={{
                                border: '1px solid #ddd',
                                borderRadius: 1,
                                padding: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1
                            }}
                        >
                            <TextField
                                label="Nome da variável"
                                value={param.name}
                                onChange={(e) => updateParameter(index, 'name', e.target.value)}
                                fullWidth
                                required
                            />

                            <TextField
                                label="Descrição"
                                value={param.description}
                                onChange={(e) => updateParameter(index, 'description', e.target.value)}
                                fullWidth
                            />

                            <TextField
                                select
                                label="Tipo"
                                value={param.type}
                                onChange={(e) => updateParameter(index, 'type', e.target.value)}
                            >
                                <MenuItem value="string">Texto</MenuItem>
                                <MenuItem value="integer">Número inteiro</MenuItem>
                                <MenuItem value="number">Número</MenuItem>
                                <MenuItem value="boolean">Verdadeiro ou falso</MenuItem>
                            </TextField>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={param.required}
                                        onChange={(e) => updateParameter(index, 'required', e.target.checked)}
                                    />
                                }
                                label="Obrigatório"
                            />

                            <TextField
                                label="Alternativas (opcional)"
                                placeholder="novo cliente, cliente existente"
                                value={param.enumValues}
                                onChange={(e) => updateParameter(index, 'enumValues', e.target.value)}
                            />

                            <Button color="error" onClick={() => removeParameter(index)}>
                                Remover parâmetro
                            </Button>
                        </Box>
                    ))}

                    <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} startIcon={<AddIcon />} onClick={addParameter}>
                        Adicionar parâmetro
                    </Button>
                </DialogContent>

                <DialogActions sx={{ padding: 2 }}>
                    <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={handleCloseToolEditor} color="inherit">
                        Cancelar
                    </Button>
                    <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} variant="contained" onClick={() => handleCreateTools(tool)}>
                        Salvar
                    </Button>
                    <Button sx={{ color: 'black', backgroundColor: '#CF8C8C' }} variant="contained" onClick={() => deleteToolFile(tool)}>
                        Apagar
                    </Button>
                </DialogActions>
            </Dialog>
            {selectedTool && (
                <Dialog
                    open={Boolean(selectedTool)}
                    onClose={onClose}
                    maxWidth={false}
                    fullWidth
                    disableEnforceFocus
                    disableAutoFocus
                    disableEscapeKeyDown={false}
                    onKeyDownCapture={(e) => {
                        if (e.key === ' ') {
                            e.stopPropagation();
                        }
                    }}
                    PaperProps={{
                        sx: {
                            width: '80vw',
                            height: '80vh',
                            maxWidth: 'none'
                        }
                    }}
                >
                    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            label="Nome da ferramenta"
                            value={newToolName}
                            onChange={(e) => setNewToolName(e.target.value)}
                            fullWidth
                        />

                        <TextField
                            label="Descrição"
                            value={toolDescription}
                            onChange={(e) => setToolDescription(e.target.value)}
                            fullWidth
                        />

                        <TextField
                            label="Prompt (Descreva as regras de sua ferramenta)"
                            value={toolDescription}
                            onChange={(e) => setToolDescription(e.target.value)}
                            fullWidth
                        />

                        <Typography variant="subtitle2">Parâmetros</Typography>

                        {parameters.map((param, index) => (
                            <Box
                                key={index}
                                sx={{
                                    border: '1px solid #ddd',
                                    borderRadius: 1,
                                    padding: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1
                                }}
                            >
                                <TextField
                                    label="Nome da variável"
                                    value={param.name}
                                    onChange={(e) => updateParameter(index, 'name', e.target.value)}
                                    fullWidth
                                />

                                <TextField
                                    label="Descrição"
                                    value={param.description}
                                    onChange={(e) => updateParameter(index, 'description', e.target.value)}
                                    fullWidth
                                />

                                <TextField
                                    select
                                    label="Tipo"
                                    value={param.type}
                                    onChange={(e) => updateParameter(index, 'type', e.target.value)}
                                >
                                    <MenuItem value="string">Texto</MenuItem>
                                    <MenuItem value="integer">Número</MenuItem>
                                    <MenuItem value="number">Número inteiro</MenuItem>
                                    <MenuItem value="boolean">Verdadeiro ou falso</MenuItem>
                                </TextField>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={param.required}
                                            onChange={(e) => updateParameter(index, 'required', e.target.checked)}
                                        />
                                    }
                                    label="Obrigatório"
                                />

                                <TextField
                                    label="Alternativas (opcional)"
                                    placeholder="novo cliente, cliente existente"
                                    value={param.enumValues}
                                    onChange={(e) => updateParameter(index, 'enumValues', e.target.value)}
                                />

                                <Button color="error" onClick={() => removeParameter(index)}>
                                    Remover parâmetro
                                </Button>
                            </Box>
                        ))}

                        <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} startIcon={<AddIcon />} onClick={addParameter}>
                            Adicionar parâmetro
                        </Button>
                    </DialogContent>

                    <DialogActions sx={{ padding: 2 }}>
                        <Button sx={{ color: 'black', backgroundColor: '#939399' }} onClick={handleCloseToolEditor} color="inherit">
                            Cancelar
                        </Button>
                        <Button sx={{ color: 'black', backgroundColor: '#7DC97D' }} variant="contained" onClick={() => saveToolFile(tool)}>
                            Salvar
                        </Button>
                        <Button
                            sx={{ color: 'black', backgroundColor: '#CF8C8C' }}
                            variant="contained"
                            onClick={() => deleteToolFile(tool)}
                        >
                            Apagar
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
